module.exports = __webpack_public_path__ + "static/img/channel.ea829de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/channel.png
// module id = Q091
// module chunks = 0